import { batchHandleUrl } from '../../../utils/url-handle'

const Api = {
  // 值对象-对象的主属性列表
  getMainFieldList: {
    url: '/apaas/object/value/mainFieldList',
    type: 'post'
  }
}

export default batchHandleUrl(Api)